export const companyData = {
  name: "Porthos Maritime",
  owner: "Porthos Maritime",
  phone: "+45 21 43 55 02",
  phoneClean: "+4521435502",
  email: "info@porthos-maritime.dk",
  address: {
    da: "Danmark",
    en: "Denmark"
  },
  logo: "https://assets.auxodev.dk/assets/565d9d77-d607-410e-a8ab-8b017e8f3d3f/3d1daa2f-9c30-44a3-8a4a-e93858eb73cd.png",
};

export const siteImages = {
  homeHero: "https://assets.auxodev.dk/assets/565d9d77-d607-410e-a8ab-8b017e8f3d3f/17b6e6ca-4134-459e-97b4-935a1260369b.JPG",
  homeIntro: "https://assets.auxodev.dk/assets/565d9d77-d607-410e-a8ab-8b017e8f3d3f/9bb69961-eae4-41ce-a148-da4323bf525c.JPG",
  offshoreWind: "https://assets.auxodev.dk/assets/565d9d77-d607-410e-a8ab-8b017e8f3d3f/97e59d34-abf0-403c-92cb-eef1dd951dea.jpeg",
  logistics: "https://assets.auxodev.dk/assets/565d9d77-d607-410e-a8ab-8b017e8f3d3f/b667512b-4993-430d-9c66-f25bd3516276.JPG",
  marineOperations: "https://assets.auxodev.dk/assets/565d9d77-d607-410e-a8ab-8b017e8f3d3f/e9b6f6ce-1d86-4f25-89b6-7344f6bbe2fc.JPG",
  contact: "https://assets.auxodev.dk/assets/565d9d77-d607-410e-a8ab-8b017e8f3d3f/c257c520-55d5-4877-a3e8-a69c2015ae68.JPG",
};

export const services = {
  da: [
    {
      id: "offshore-vind",
      title: "Offshore Vind",
      shortDescription: "Ekspertise inden for offshore vind-projekter med fokus på sikkerhed, effektivitet og præcision.",
      fullDescription: "Porthos Maritime tilbyder omfattende ekspertise inden for offshore vind-projekter. Med fokus på sikkerhed, effektivitet og præcision hjælper Porthos Maritime med planlægning og eksekvering af maritime operationer i forbindelse med vindmølleparker.\n\nTilgangen er personlig og professionel, hvilket sikrer, at hver opgave bliver løst med største omhu.",
      bodyParagraphs: [
        "Som dedikeret partner i den maritime sektor lægger Porthos Maritime vægt på at forstå de specifikke behov i hvert projekt. Rollen er at sikre, at offshore vind bliver håndteret med den højeste grad af professionalisme og teknisk indsigt.",
        "Porthos Maritime leverer ekspertise inden for offshore vind-projekter. Med fokus på effektivitet, præcision og sikkerhed bliver planlægningen nøje gennemgået og justeret for at sikre en optimal eksekvering af processen og projektet.",
        "Porthos Maritime har stor erfaring inden for havvindmølleparker og har deltaget i projekter i både planlægnings- og installationsfasen.",
        "Som dedikeret partner inden for offshore vind sikrer Porthos Maritime, at arbejdet lever op to best practice, og at skibe, installationsfartøjer, pramme og crew transfer vessels opfylder krav og behov samt leverer de indgåede ydelser.",
        "Konsulentbistanden kan være administrativ, hands-on eller en kombination af begge dele. Arbejdet kan foregå som hybrid, på kundens kontor, på Site Office eller offshore."
      ],
      image: siteImages.offshoreWind,
      features: [
        "Projektstyring",
        "Maritim koordination",
        "Sikkerhedsvurdering",
        "Skibs/havne inspektion"
      ],
      contactText: "Har I spørgsmål til offshore vind? Ring eller skriv for en uforpligtende snak."
    },
    {
      id: "logistik",
      title: "Logistik",
      shortDescription: "Planlægning og koordinering af fragt, udstyr og mandskab i maritime projekter.",
      fullDescription: "Logistik i det maritime miljø kræver præcision og erfaring. Porthos Maritime varetager planlægning og koordinering af fragt, udstyr og mandskab, så operationerne forløber gnidningsfrit.\n\nSom personlig partner sikrer Porthos Maritime, at alle logistiske udfordringer bliver håndteret proaktivt.",
      bodyParagraphs: [
        "Som dedikeret partner i den maritime sektor lægger Porthos Maritime vægt på at forstå de specifikke behov i hvert projekt. Rollen er at sikre, at logistik bliver håndteret med den højeste grad af professionalisme og teknisk indsigt.",
        "Porthos Maritime leverer optimale løsninger i forbindelse med heavy-lift transporter samt transport af mandskab. I forbindelse med planlægningen udføres også inspektioner af egnede fartøjer og rådgivning i forbindelse med indchartring.",
        "Porthos Maritime varetager supply-chain funktionen for kunden og kan samtidig bistå med set-up i havne, hvor der foretages udskibninger, eller som bruges som base-port for personnel, forbrugsvarer og reservedele.",
        "Kontakten med havne, agenter og lokale myndigheder i forbindelse med disse operationer indgår som en naturlig del af konceptet."
      ],
      image: siteImages.logistics,
      features: [
        "Flådestyring",
        "Ressourceoptimering",
        "Forsyningskæder",
        "On Site Management"
      ],
      contactText: "Har I spørgsmål til logistik? Ring eller skriv for en uforpligtende snak."
    },
    {
      id: "marine-operationer",
      title: "Marine Operationer",
      shortDescription: "Teknisk support og operativ ledelse til komplekse marine operationer.",
      fullDescription: "Porthos Maritime har stor erfaring med komplekse marine operationer. Fra teknisk support to operativ ledelse på dækket leveres løsninger, der er skræddersyet til kundens behov.\n\nMed ét kontaktpunkt sikres en smidig proces og høj kvalitet i hver enkelt opgave.",
      bodyParagraphs: [
        "Som dedikeret partner i den maritime sektor lægger Porthos Maritime vægt på at forstå de specifikke behov i hvert projekt. Rollen er at sikre, at marine operationer bliver håndteret med den højeste grad af professionalisme og teknisk indsigt.",
        "Porthos Maritime har stor erfaring med komplekse marine operationer. Fra teknisk support to operativ ledelse både onshore og offshore.",
        "I forbindelse med marine operationer er det høj prioritet, at der er mindst mulig down-time. Med Porthos Maritime som omdrejningspunkt og første kontakt sikres en smidig proces i hver enkelt opgave.",
        "Med Porthos Maritimes viden omkring marine operationer skabes et optimalt resultat, hvor skibe, udstyr og mandskab bruges med hensyn til deres respektive kapaciteter. Sikkerheden prioriteres højt, så alle kommer sikkert hjem, og udstyret er intakt til næste projekt."
      ],
      image: siteImages.marineOperations,
      features: [
        "Teknisk rådgivning",
        "Operativ ledelse",
        "Udstyrshåndtering",
        "Kvalitetskontrol"
      ],
      contactText: "Har I spørgsmål til marine operationer? Ring eller skriv for en uforpligtende snak."
    }
  ],
  en: [
    {
      id: "offshore-wind",
      title: "Offshore Wind",
      shortDescription: "Expertise in offshore wind projects with a focus on safety, efficiency, and precision.",
      fullDescription: "Porthos Maritime offers comprehensive expertise in offshore wind projects. With a focus on safety, efficiency, and precision, Porthos Maritime assists with the planning and execution of marine operations related to wind farms.\n\nThe approach is personal and professional, ensuring that every task is resolved with the utmost care.",
      bodyParagraphs: [
        "As a dedicated partner in the maritime sector, Porthos Maritime emphasizes understanding the specific needs of each project. Our role is to ensure that offshore wind is handled with the highest level of professionalism and technical insight.",
        "Porthos Maritime delivers expertise in offshore wind projects. With a focus on efficiency, precision, and safety, planning is carefully reviewed and adjusted to ensure optimal execution of the process and project.",
        "Porthos Maritime has extensive experience in offshore wind farms and has participated in projects in both the planning and installation phases.",
        "As a dedicated partner in offshore wind, Porthos Maritime ensures that the work complies with best practice and that vessels, installation vessels, barges, and crew transfer vessels meet requirements and deliver the agreed services.",
        "Consultancy services can be administrative, hands-on, or a combination of both. The work can take place as hybrid, at the client's office, at the Site Office, or offshore."
      ],
      image: siteImages.offshoreWind,
      features: [
        "Project Management",
        "Marine Coordination",
        "Safety Assessment",
        "Vessel/Port Inspection"
      ],
      contactText: "Do you have questions about offshore wind? Call or write for an informal chat."
    },
    {
      id: "logistics",
      title: "Logistics",
      shortDescription: "Planning and coordination of cargo, equipment, and crew in maritime projects.",
      fullDescription: "Logistics in the maritime environment requires precision and experience. Porthos Maritime manages the planning and coordination of cargo, equipment, and crew, ensuring operations run smoothly.\n\nAs a personal partner, Porthos Maritime ensures that all logistical challenges are handled proactively.",
      bodyParagraphs: [
        "As a dedicated partner in the maritime sector, Porthos Maritime emphasizes understanding the specific needs of each project. Our role is to ensure that logistics is handled with the highest level of professionalism and technical insight.",
        "Porthos Maritime delivers optimal solutions for heavy-lift transport and crew transport. In connection with planning, inspections of suitable vessels and advice on chartering are also carried out.",
        "Porthos Maritime manages the supply chain function for the client and can also assist with set-up in ports where shipments are made, or which are used as base ports for personnel, consumables, and spare parts.",
        "Contact with ports, agents, and local authorities in connection with these operations is a natural part of the concept."
      ],
      image: siteImages.logistics,
      features: [
        "Fleet Management",
        "Resource Optimization",
        "Supply Chains",
        "On Site Management"
      ],
      contactText: "Do you have questions about logistics? Call or write for an informal chat."
    },
    {
      id: "marine-operations",
      title: "Marine Operations",
      shortDescription: "Technical support and operational management for complex marine operations.",
      fullDescription: "Porthos Maritime has extensive experience with complex marine operations. From technical support to operational management on deck, we deliver solutions tailored to the client's needs.\n\nWith a single point of contact, a smooth process and high quality are ensured in every single task.",
      bodyParagraphs: [
        "As a dedicated partner in the maritime sector, Porthos Maritime emphasizes understanding the specific needs of each project. Our role is to ensure that marine operations are handled with the highest level of professionalism and technical insight.",
        "Porthos Maritime has extensive experience with complex marine operations. From technical support to operational management both onshore and offshore.",
        "In connection with marine operations, minimizing downtime is a high priority. With Porthos Maritime as the focal point and first contact, a smooth process is ensured in every single task.",
        "With Porthos Maritime's knowledge of marine operations, an optimal result is created where vessels, equipment, and crew are used with respect to their respective capacities. Safety is highly prioritized, ensuring everyone returns home safely and equipment is intact for the next project."
      ],
      image: siteImages.marineOperations,
      features: [
        "Technical Advisory",
        "Operational Management",
        "Equipment Handling",
        "Quality Control"
      ],
      contactText: "Do you have questions about marine operations? Call or write for an informal chat."
    }
  ]
};

export const navigation = {
  da: [
    { name: "Forside", href: "/" },
    { name: "Ydelser", href: "/ydelser" },
    { name: "Kontakt", href: "/kontakt" },
  ],
  en: [
    { name: "Home", href: "/en" },
    { name: "Services", href: "/en/services" },
    { name: "Contact", href: "/en/contact" },
  ]
};
